import {Service} from "@/services/superclasses/service";
import {OrganizationNumber} from "@/interfaces/organization-number";

const api = window.contextPath + '/rest/supplements';

export class OrganizationNumberService extends Service {

    public loadByMember = async (memberId: number): Promise<OrganizationNumber> => {
        return this.data(await this.get<OrganizationNumber>(api + "/by-member/" + memberId));
    }
}

export const organizationNumberService = new OrganizationNumberService()